import { ReactNode } from "react";

import styles from "../../styles/TextHighlight.module.less";

type TextHighlightProps = {
  weight?: "bold" | "medium";
  variant?: "primary" | "success" | "danger";
  children: ReactNode;
};

/** strong primary color inline text */
const TextHighlight = ({ variant = "primary", weight = "bold", children }: TextHighlightProps) => {
  return (
    <strong
      className={`${styles.highlight} ${styles[`weight-${weight}`]} ${
        styles[`variant-${variant}`]
      }`}
    >
      {children}
    </strong>
  );
};

export default TextHighlight;
